import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import axios from '../../../lib/axios';
import { EMPLOYEE_CHANGE_PASSWORD } from '../../../lib/endpoints/auth';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

const useChangePasswordController = () => {
  const { t } = useTranslation('global');

  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [loadingConfirm, setLoadingConfirm] = useState<boolean>(false);
  const auth = useSelector((state: RootState) => state?.auth);
  const oldPassword = useRef<HTMLInputElement>(null!);
  const password = useRef<HTMLInputElement>(null!);
  const confirmPassword = useRef<HTMLInputElement>(null!);

  const handleChangePassword = async () => {
    try {
      setLoadingConfirm(true);
      await axios.post(EMPLOYEE_CHANGE_PASSWORD, {
        user_name: auth?.data?.username,
        old_password: oldPassword?.current.value,
        new_password: password?.current.value,
      });
      setOpenConfirm(false);
      alert('Complete change password.');
      handleResetForm();
    } catch (err: any) {
      try {
        const getErrorMessage: any = err.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirm(false);
    }
  };

  const handleResetForm = () => {
    oldPassword.current.value = '';
    password.current.value = '';
    confirmPassword.current.value = '';
  };

  const handleValidate = () => {
    if (password.current?.value !== confirmPassword.current?.value) {
      setErrorMessage('Password and Confirm Password do not match.');
      return false;
    }
    if (password?.current?.value.length < 8) {
      setErrorMessage('Password must be at least greater than or equal to 8 digits');
      return false;
    }
    if (confirmPassword?.current?.value.length < 8) {
      setErrorMessage('Password must be at least greater than or equal to 8 digits');
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleOpenConfirmForm = (e: React.FormEvent) => {
    e.preventDefault();
    if (handleValidate()) {
      setOpenConfirm(true);
    }
  };

  const handleCloseConfirmForm = () => {
    setOpenConfirm(false);
  };

  return {
    handleChangePassword,
    handleOpenConfirmForm,
    handleCloseConfirmForm,
    oldPassword,
    password,
    loadingConfirm,
    openConfirm,
    errorMessage,
    confirmPassword,
  };
};
export default useChangePasswordController;
